import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Checkbox, Radio } from "antd";
import { Prices } from "../components/Prices";
import { useCart } from "../context/cart";
import axios from "axios";
import toast from "react-hot-toast";
import Layout from "./../components/Layout/Layout";
import { AiOutlineReload } from "react-icons/ai";
import "../styles/Homepage.css";

const HomePage = () => {
  const navigate = useNavigate();

  const [cart, setCart] = useCart();

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [checked, setChecked] = useState([]);
  const [radio, setRadio] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  // get all categories
  const getAllCategory = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/category/get-category`,
      );

      if (data?.success) {
        setCategories(data?.category);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // get total count
  const getTotal = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/product/product-count`,
      );

      setTotal(data?.total);
    } catch (error) {
      console.log(error);
    }
  };

  // get all products
  const getAllProducts = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/product/product-list/${page}`,
      );

      setLoading(false);
      setProducts(data?.products);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [page]);

  // load more products
  const loadMore = useCallback(async () => {
    try {
      setLoading(true);

      const { data } = await axios.get(
        `${process.env.REACT_APP_API}/api/v1/product/product-list/${page}`,
      );

      setLoading(false);

      setProducts((prev) => [...prev, ...data?.products]);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [page]);

  // filter products
  const filterProduct = useCallback(async () => {
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/api/v1/product/product-filters`,
        {
          checked,
          radio,
        },
      );

      setProducts(data?.products);
    } catch (error) {
      console.log(error);
    }
  }, [checked, radio]);

  // initial load
  useEffect(() => {
    getAllCategory();
    getTotal();
  }, []);

  // load more when page changes
  useEffect(() => {
    if (page === 1) return;

    loadMore();
  }, [page, loadMore]);

  // get products
  useEffect(() => {
    if (!checked.length || !radio.length) {
      getAllProducts();
    }
  }, [checked.length, radio.length, getAllProducts]);

  // filter products
  useEffect(() => {
    if (checked.length || radio.length) {
      filterProduct();
    }
  }, [checked, radio, filterProduct]);

  // handle filter
  const handleFilter = (value, id) => {
    let all = [...checked];

    if (value) {
      all.push(id);
    } else {
      all = all.filter((c) => c !== id);
    }

    setChecked(all);
  };

  return (
    <Layout title={"ALl Products - Best offers "}>
      {/* Banner */}
      <div>
        <div id="carouselExampleCaptions" className="carousel slide">
          <div className="carousel-indicators">
            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="0"
              className="active"
              aria-current="true"
              aria-label="Slide 1"
            ></button>

            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="1"
              aria-label="Slide 2"
            ></button>

            <button
              type="button"
              data-bs-target="#carouselExampleCaptions"
              data-bs-slide-to="2"
              aria-label="Slide 3"
            ></button>
          </div>

          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src="/images/cbg2.jpg" className="d-block w-100" alt="..." />

              <div className="carousel-caption d-none d-md-block">
                <h5>Unleash Your Style</h5>
                <p>- Shop the Trendiest Fashion Today!</p>
              </div>
            </div>

            <div className="carousel-item">
              <img
                src="/images/cbg3_1.jpg"
                className="d-block w-100"
                alt="..."
              />

              <div className="carousel-caption d-none d-md-block">
                <h5>Discover Your Perfect Fit</h5>
                <p>- Find the Ideal Products for You.</p>
              </div>
            </div>

            <div className="carousel-item">
              <img src="/images/cbg1.jpg" className="d-block w-100" alt="..." />

              <div className="carousel-caption d-none d-md-block">
                <h5>Your Fashion Destination</h5>
                <p>- Discover Endless Style Possibilities.</p>
              </div>
            </div>
          </div>

          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="prev"
          >
            <span
              className="carousel-control-prev-icon"
              aria-hidden="true"
            ></span>

            <span className="visually-hidden">Previous</span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#carouselExampleCaptions"
            data-bs-slide="next"
          >
            <span
              className="carousel-control-next-icon"
              aria-hidden="true"
            ></span>

            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      {/* Main */}
      <div className="container-fluid row mt-3 home-page">
        {/* Filters */}
        <div className="col-md-3 filters p-4 stylish-card">
          <h4 className="text-center stylish-heading">🎯 Filter by Category</h4>

          <div className="d-flex flex-column gap-3">
            {categories?.map((c) => (
              <Checkbox
                key={c._id}
                onChange={(e) => handleFilter(e.target.checked, c._id)}
                className="custom-checkbox"
              >
                {c.name}
              </Checkbox>
            ))}
          </div>

          {/* Price Filter */}
          <h4 className="text-center stylish-heading mt-4">
            💰 Filter by Price
          </h4>

          <div className="d-flex flex-column gap-3">
            <Radio.Group
              onChange={(e) => setRadio(e.target.value)}
              className="custom-radio-group"
            >
              {Prices?.map((p) => (
                <div key={p._id} className="custom-radio">
                  <Radio value={p.array}>{p.name}</Radio>
                </div>
              ))}
            </Radio.Group>
          </div>

          {/* Reset */}
          <div className="d-flex justify-content-center mt-4">
            <button
              className="btn stylish-reset-btn"
              onClick={() => window.location.reload()}
            >
              🔄 Reset Filters
            </button>
          </div>
        </div>

        {/* Products */}
        <div className="col-md-9 product-section">
          <h1 className="text-center stylish-heading mb-4">All Products</h1>

          <div className="d-flex flex-wrap justify-content-center">
            {products?.map((p) => (
              <div className="card m-2 stylish-card" key={p._id}>
                <img
                  src={`${process.env.REACT_APP_API}/api/v1/product/product-photo/${p._id}`}
                  className="card-img-top product-img"
                  alt={p.name}
                />

                <div className="card-body">
                  <div className="card-name-price mb-3">
                    <h5 className="card-title product-title">{p.name}</h5>

                    <h5 className="card-title product-price">
                      {p.price.toLocaleString("en-US", {
                        style: "currency",
                        currency: "USD",
                      })}
                    </h5>
                  </div>

                  <p className="card-text product-description">
                    {p.description.substring(0, 60)}
                    ...
                  </p>

                  <div className="card-actions">
                    <button
                      className="btn btn-info ms-1 action-btn"
                      onClick={() => navigate(`/product/${p.slug}`)}
                    >
                      Details
                    </button>

                    <button
                      className="btn btn-dark ms-1 action-btn"
                      onClick={() => {
                        setCart([...cart, p]);

                        localStorage.setItem(
                          "cart",
                          JSON.stringify([...cart, p]),
                        );

                        toast.success("Item Added to cart");
                      }}
                    >
                      ADD TO CART
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Load More */}
          <div className="m-2 p-3">
            {products && products.length < total && (
              <button
                className="btn loadmore stylish-btn"
                onClick={(e) => {
                  e.preventDefault();
                  setPage(page + 1);
                }}
              >
                {loading ? (
                  "Loading ..."
                ) : (
                  <>
                    Load more <AiOutlineReload />
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default HomePage;
